export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14559.5648d42a.jpg";